<template>
  <div>
    <!--Messages d'erreur-->
    <div class="justify-content-center mx-auto col-12 error-messages-container">
      <Alert
        type="danger"
        message="Nous ne parvenons pas à traiter cette adresse email. Vérifiez votre saisie."
        :visible="mailError"
        @close="mailError = false" />

      <Alert
        type="danger"
        message="Nous ne parvenons pas à envoyer l'email. Réessayez dans quelques instants."
        :visible="servError"
        @close="servError = false" />

      <Alert
        type="success"
        :message="`Un email a été envoyé à l'adresse ${sentToEmail}`"
        :visible="success"
        @close="success = false" />
    </div>
    <!--#Messages d'erreur-->

    <div class="row justify-content-center">
      <form @submit="formSubmit" class="col-12" novalidate>
        <fieldset class="login-fields-container">
          <div class="form-group row">
            <label for="emailInput" class="col-sm-12 col-md-5 col-form-label">
              Adresse email
            </label>
            <div class="col-sm-12 col-md-7">
              <input id="emailInput"
                     type="email"
                     class="form-control"
                     v-model="mail"
                     :class="{ 'is-invalid': formSubmitted && this.$v.mail.$error }"
                     @input="onEmailInput"
                     placeholder="monadresse@mail.com">
              <div v-if="formSubmitted && this.$v.mail.$error" class="mt-1">
                <div class="text-danger small" v-if="!this.$v.mail.required">
                  Champ requis
                </div>
                <div class="text-danger small" v-if="!this.$v.mail.email">
                  Adresse email invalide
                </div>
              </div>
            </div>
          </div>
        </fieldset>

        <div class="row justify-content-center my-4">
          <div class="col-12 col-sm-8 mt-3">
            <button type="submit" class="btn btn-block btn-sm text-white fond-indigo">
              {{
                type === 'recovery'
                  ? 'Envoyer le lien de récupération'
                  : 'Envoyer le lien d\'inscription'
              }}
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { required, email } from 'vuelidate/lib/validators';
import axios from 'axios';
import Alert from '../Alert.vue';

export default {
  name: 'EmailForm',
  props: {
    type: String,
  },
  data() {
    return {
      mail: '',
      sentToEmail: '', // Email sauvegardé pour l'affichage
      formSubmitted: false,
      mailError: false,
      servError: false,
      success: false,
    };
  },
  components: {
    Alert,
  },
  methods: {
    onEmailInput() {
      this.mail = this.mail.toLowerCase().trim();
      this.$v.mail.$touch();
      if (this.formSubmitted) this.formSubmitted = false;
      this.mailError = false;
      this.servError = false;
    },
    formSubmit(e) {
      e.preventDefault();
      this.formSubmitted = true;
      this.$v.$touch();

      if (this.$v.$invalid) {
        return;
      }

      const emailData = {
        mail: this.mail,
        type: this.type,
        source: this.$parent.source || 'Portail',
      };

      axios.post('/auth/api/front/mail', JSON.stringify(emailData), {
        headers: { 'content-type': 'application/json' },
      })
        .then(() => {
          // Sauvegarder l'email avant de vider le formulaire
          this.sentToEmail = this.mail;
          this.success = true;
          // Reset form après succès
          this.mail = '';
          this.formSubmitted = false;
          this.$v.$reset();
        })
        .catch((error) => {
          // Pour la récupération de mot de passe, un 404 signifie email introuvable
          if (this.type === 'recovery' && error.response && error.response.status === 404) {
            this.mailError = true;
          } else {
            // Pour la création de compte ou toute autre erreur
            this.servError = true;
          }
        });
    },
  },
  validations: {
    mail: {
      required,
      email,
    },
  },
};
</script>

<style scoped>
.login-fields-container {
  margin-left: 8px;
}

.error-messages-container {
  margin-bottom: 25px !important;
}
</style>
